export const generateAriaLabel = {
  wishlist: {
    add: (type: 'accommodation' | 'service', name?: string) =>
      name ? `Add ${name} to wishlist` : `Add ${type} to wishlist`,
    remove: (type: 'accommodation' | 'service', name?: string) =>
      name ? `Remove ${name} from wishlist` : `Remove ${type} from wishlist`,
    unauthenticated: 'Sign in to add to wishlist',
    added: (type: 'accommodation' | 'service', name?: string) =>
      `${name || type} added to wishlist`,
  },

  cart: {
    add: (type: 'accommodation' | 'service', name?: string) =>
      name ? `Add ${name} to cart` : `Add ${type} to cart`,
    remove: (type: 'accommodation' | 'service', name?: string) =>
      name ? `Remove ${name} from cart` : `Remove ${type} from cart`,
    update: (action: 'increase' | 'decrease', name?: string) =>
      name
        ? `${action === 'increase' ? 'Increase' : 'Decrease'} quantity for ${name}`
        : `${action === 'increase' ? 'Increase' : 'Decrease'} quantity`,
  },

  navigation: {
    goTo: (destination: string) => `Navigate to ${destination}`,
    openMenu: 'Open navigation menu',
    closeMenu: 'Close navigation menu',
    toggleMobileMenu: 'Toggle mobile navigation menu',
  },

  form: {
    required: (fieldName: string) => `${fieldName} (required)`,
    optional: (fieldName: string) => `${fieldName} (optional)`,
    submit: (formType: string) => `Submit ${formType} form`,
    clear: (formType: string) => `Clear ${formType} form`,
    search: 'Search accommodations and services',
  },

  media: {
    image: (name?: string, index?: number) =>
      name ? `Image of ${name}${index ? ` (${index} of multiple)` : ''}` : 'Property image',
    video: (name?: string) => (name ? `Video of ${name}` : 'Property video'),
    gallery: (current: number, total: number) => `Image ${current} of ${total}`,
  },

  status: {
    loading: (action?: string) => (action ? `Loading ${action}` : 'Loading'),
    error: (context?: string) => (context ? `Error: ${context}` : 'An error occurred'),
    success: (action?: string) =>
      action ? `${action} successful` : 'Action completed successfully',
  },

  booking: {
    selectDate: 'Select booking dates',
    selectGuests: 'Select number of guests',
    viewDetails: (name?: string) => (name ? `View details for ${name}` : 'View property details'),
    bookNow: (name?: string) => (name ? `Book ${name} now` : 'Book now'),
  },
};

export const getLoadingAriaProps = (isLoading: boolean, loadingText?: string) => ({
  'aria-busy': isLoading,
  ...(isLoading && { 'aria-label': loadingText || 'Loading' }),
});

export const getAnnouncementProps = (
  message: string,
  priority: 'polite' | 'assertive' = 'polite',
) => ({
  'aria-live': priority,
  'aria-atomic': true,
  role: priority === 'assertive' ? 'alert' : 'status',
});

export const getSkipLinkProps = (target: string) => ({
  href: `#${target}`,
  className: 'skip-link',
  'aria-label': `Skip to ${target.replace('-', ' ')}`,
});
